module.exports = __webpack_public_path__ + "static/media/aditi.2d3c24bf.jpg";